import { useCallback } from 'react';
import { useEnqueueAutomationMove } from './useEnqueueAutomationMove';
import { useTriggerAutomationSilently } from './useTriggerAutomationSilently';
import { fetchPendingExecutionsForApplications } from './workflowExecutions.api';
import {
  buildEnqueueInputFromExecutions,
  alreadyRanTriggerInput,
} from './dispatchSession.helpers';

// Opens the underway popup after a *synchronous* add-to-job. These endpoints
// create the pending executions inline (nothing to poll), so look them up by
// application id. No-ops when the stage has no automation. Gate callers on
// `feStageAutomation`.
export const useEnqueueAddToJobAutomation = () => {
  const enqueue = useEnqueueAutomationMove();
  const triggerSilently = useTriggerAutomationSilently();

  return useCallback(
    async (applicationIds: Array<string | number | undefined | null>) => {
      const ids = (applicationIds ?? []).filter(
        (id): id is string | number => id !== null && id !== undefined
      );
      if (ids.length === 0) return;

      const executions = await fetchPendingExecutionsForApplications(ids);
      // Single add → single-candidate row (name + avatar); multiple → bulk row.
      const input = buildEnqueueInputFromExecutions(executions, {
        isBulk: ids.length > 1,
      });
      if (input) enqueue(input);
      // Executions the row skipped (first step already ran) still need their
      // trigger, else the BE never runs the stage's remaining activities.
      void triggerSilently(alreadyRanTriggerInput(executions));
    },
    [enqueue, triggerSilently]
  );
};
